<template>
  <div class="content">
    <!-- New mortgage jumbo -->
    <Jumbo class="new-mortgage-jumbo">
      <template #before>
        <div class="new-mortgage-jumbo__image">
          <ImageComponent src="img/web/new-mortgage-picto.webp" alt="Imagen comprar vivienda" width="606"></ImageComponent>
        </div>
      </template>

      <template #after>
        <div class="new-mortgage-jumbo__content">
          <h2>Quiero comprar una vivienda</h2>
          <ul>
            <li>Te daremos una visión realista de tu capacidad de compra.</li>
            <li>Te daremos varias opciones entre las que elegir, con condiciones que no te ofrecerían como particular.</li>
            <li>Te acompañaremos en todo el proceso, desde la negociación con las entidades, hasta la firma de tu hipoteca.</li>
            <li>Todo ello lo haremos gratis.</li>
          </ul>
          <Button tag="a" :href="route('funnel.new')" class="new-mortgage-jumbo__content__button">
            Simular mi hipoteca
          </Button>
        </div>
      </template>
    </Jumbo>
  </div>
</template>

<style lang="postcss" scoped>
.content {
  @apply flex flex-col items-center bg-support-dark;

  .new-mortgage {
    &-jumbo {
      &__image {
        @apply flex justify-center items-center mx-auto xl:w-4/5 max-w-[12.25rem] lg:max-w-none;
      }

      &__content {
        @apply flex flex-col gap-y-xxs lg:pl-xl text-neutral-white max-w-sm lg:max-w-3xl;

        h2 {
          @apply style-subtitle-bold;
        }

        ul {
          @apply list-none lg:list-[initial];

          li {
            @apply style-body my-xxxs;
          }
        }

        &__button {
          @apply lg:self-start;
        }
      }

      /deep/ .jumbo {
        &__content {
          @apply justify-center;
        }
      }
    }
  }
}
</style>

<script>
import Jumbo from '@/lego/components/layout/Jumbo.vue';
import Button from '@/lego/components/buttons/Button.vue';
import ImageComponent from '@/lego/components/images/Image.vue';

export default {
  components: {
    Jumbo,
    Button,
    ImageComponent,
  },
};
</script>
